import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import React from 'react';

type SelectClearButtonProps = {
  show: boolean;
  label: string;
  onClear: () => void;
};

const SelectClearButton = ({ show, label, onClear }: SelectClearButtonProps): JSX.Element | null => {
  if (!show) return null;

  return (
    <IconButton
      aria-label={`Clear ${label}`}
      size="small"
      onMouseDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.stopPropagation();
        onClear();
      }}
      sx={{
        position: 'absolute',
        right: 28,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        padding: '2px',
        color: '#6B7280',
        '&:hover': {
          backgroundColor: 'rgba(23, 36, 51, 0.06)',
          color: '#172433',
        },
      }}
    >
      <CloseIcon sx={{ fontSize: 16 }} />
    </IconButton>
  );
};

export default SelectClearButton;
